<template>
    <div class="header-container">
      <div class="d-flex flex-column" id="home-profile">
        <div class="header_row d-flex flex-column flex-sm-row justify-content-center align-items-center justify-content-sm-between">
          <div>
            <router-link to="/home">
              <img class="logo_icon" src="../assets/new_logo.png" alt="Home">
            </router-link>
          </div>
          <div>
            <h2 style="font-weight: bold;">{{ title }}</h2> 
          </div>
          <div class="d-flex flex-row">
            <div class="d-flex flex-row justify-content-center justify-content-sm-end">
              {{ username }}&nbsp;|&nbsp;
            </div>
            <!-- <div class="d-flex flex-row justify-content-center justify-content-sm-end">
              {{ branch }}
            </div> -->
            <div class="d-flex flex-row justify-content-center justify-content-sm-end">
              <span>{{ currentDate }}</span>
              <span> | </span>
              <span>{{ currentTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
  <script>
  export default {
    name: 'AppHeader',
    props: {
     
      restaurantName: {
        type: String,
        default: 'Restaurant Name'
      },
      title: {
      type: String,
      default: localStorage.getItem('branchName') 
    }
    },
    data() {
      return {
        currentDate: '',
        currentTime: '',
        username: localStorage.getItem('username') || 'Username',
        branch: localStorage.getItem('branchName'),

      };
    },
    mounted() {
      this.updateDateTime();
      this.startDateTimeUpdate();
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        });
        this.currentTime = now.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      },
      startDateTimeUpdate() {
        setInterval(() => {
          this.updateDateTime();
        }, 1000);
      }
    }
  };
  </script>

<style scoped>
.header-container {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; 
  background: var(--bg-color);
  /* height: 6rem; */
  color: var(--font-color);
}
body.class-1{
  padding: none;
}
</style>